import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  IClaimLandingRequestParams,
} from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import { getLobOnServerSide } from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getClaimLandingDetails = async (
  data: IClaimLandingRequestParams
): Promise<any> => {
  try {
    const { partner, bookingId, headers, cmp, query, dvid } = data || {};
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId,
      ...query,
    };

    const urlParams = setURLQueryParams(params);

    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.CLAIM_LANDING}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp, dvid },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching claim landing details", { error });
    throw error;
  }
};
